<div class="rd-header">
  <div class="rd-header-top">
    <mat-chip class="cd-chip" [ngClass]="'cd-chip--' + categoryClass()" disableRipple>
      <mat-icon matChipAvatar>{{ categoryIcon() }}</mat-icon>
      {{ report.category }}
    </mat-chip>

    <span class="cd-priority" [ngClass]="'cd-priority--' + report.priority.toLowerCase()">
      <span class="cd-priority-dot" aria-hidden="true"></span>{{ report.priority }}
    </span>

    <button
      data-testid="issue-reports-close"
      mat-icon-button
      class="rd-close"
      aria-label="Close"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <h2 class="rd-title">{{ report.title }}</h2>

  <p class="rd-meta">
    {{ report.school?.name }}
    &middot; opened {{ report.submittedDate | date: 'MMM d, y, h:mm a' }}
  </p>
</div>

<mat-dialog-content class="rd-content">
  <div class="rd-status-block">
    <div class="rd-status-header">
      <span class="rd-label">Status</span>

      <mat-form-field
        *hasPermission="permissions.REPORTS.MANAGE_STATUS"
        appearance="outline"
        class="rd-status-select"
        subscriptSizing="dynamic"
      >
        <mat-select
          [ngModel]="report.status"
          (ngModelChange)="changeStatus($event)"
          [disabled]="statusUpdating"
          aria-label="Change report status"
          data-testid="issue-reports-status-select"
        >
          @for (s of statuses; track s) {
            <mat-option [value]="s">{{ s }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <app-status-stepper [status]="report.status"></app-status-stepper>
  </div>

  <p class="rd-description">{{ report.description }}</p>

  @if (report.media.length > 0) {
    <div class="rd-media">
      <span class="rd-label">Attachments</span>
      <div class="rd-media-list">
        @for (m of report.media; track m.id) {
          <a class="rd-media-chip" [href]="attachmentPath(m.path)" target="_blank" rel="noopener">
            <mat-icon>attach_file</mat-icon>
            {{ m.filename }}
          </a>
        }
      </div>
    </div>
  }

  <div class="rd-assignee-row">
    <span class="rd-label">Assigned to</span>

    @if (canAssign) {
      <mat-form-field appearance="outline" class="rd-status-select" subscriptSizing="dynamic">
        <mat-select
          [ngModel]="report.assignedTo ?? null"
          (ngModelChange)="changeAssignee($event)"
          [disabled]="assigneeUpdating"
          aria-label="Assign report to a user"
          data-testid="issue-reports-assignee-select"
        >
          <mat-option [value]="null">Unassigned</mat-option>
          @for (u of assignableUsers; track u.id) {
            <mat-option [value]="u.id">{{ assignableLabel(u) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    } @else if (report.assignedTo === null || report.assignedTo === undefined) {
      <span class="rd-unassigned">Not yet assigned</span>
    } @else {
      <span class="cd-assignee">
        <span class="cd-avatar" aria-hidden="true">
          <app-user-avatar [imageUrl]="assigneeImageUrl()" [name]="assigneeLabel()" />
        </span>
        {{ assigneeLabel() }}
      </span>
    }
  </div>
</mat-dialog-content>
